import Form from './Form'
window.Form = Form

import Alert from './Alert'
window.Alert = Alert

import Toast from './Toast'
window.Toast = Toast

import Storage from './Storage'
window.Storage = Storage
